<!-- positions-section.component.html -->
<div class="positions-section">
  @if(sectionTitle) {
    <div class="section-header pl-5 border-top-1 surface-border flex align-items-center gap-2">
      @if(selectable) {
        <input type="checkbox" class="staff-select-checkbox section-select-all"
          [checked]="allSelected"
          [indeterminate]="someSelected"
          (change)="onSectionSelectionToggle($any($event.target).checked)"
          [attr.aria-label]="'Select all ' + sectionTitle"
          [pTooltip]="allSelected ? 'Deselect all' : 'Select all'" tooltipPosition="top">
      }
      <div class="p-element "><span class="m-0 text-900 font-semibold">{{ sectionTitle }}</span></div>
      @if(selectable && isCollapsed && selectedCount > 0) {
        <span class="selected-badge">{{ selectedCount }} selected</span>
      }
      <div class="flex align-items-center gap-1" style="margin-left: auto;">
        @if(showRoleGroupChat){
          <p-button class="action-icon" pTooltip="Message Group" 
            (click)="onOpenRoleGroupChat()" 
            tooltipPosition="top" [rounded]="true" [text]="true" icon="true">
            <span class="{{helperService.getEnvironmentName()}}-icon icon-forum-outlined"></span>
          </p-button>
        }
        <p-button [pTooltip]="isCollapsed ? 'Expand' : 'Collapse'"
          (click)="toggleCollapse()"
          tooltipPosition="top" [rounded]="true" [text]="true" [plain]="true"
          [icon]="isCollapsed ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
          [size]="'large'" class="row-toggler">
        </p-button>
      </div>
    </div>
  }
  @if(!isCollapsed) {
  <p-table 
    [value]="positions" 
    dataKey="_id" 
    [customSort]="showSorting"
    (sortFunction)="onSortPositions($event)"
    [styleClass]="tableStyleClass"
    autoLayout="true" [scrollable]="true"
    class="p-table-user-list"
  >
    <ng-template pTemplate="header">
      <tr>
        @if(selectable) {
          <th class="pl-5 select-col"></th>
        }
        <th [class.pl-5]="!selectable" style="width: 22%;" [pSortableColumn]="showSorting ? 'candidateName' :'' ">
          Candidate
          @if(showSorting) {
            <p-sortIcon field="candidateName"></p-sortIcon>
          }
        </th>
        <th style="width: 15%;" [pSortableColumn]="showSorting ? 'rating' : ''">
          {{'Star Rating' | sentenceCase}}
          @if(showSorting) {
            <p-sortIcon field="rating"></p-sortIcon>
          }
        </th>
        @if(isPWCEnabled){
          <th style="width: 15%;" [pSortableColumn]="showSorting ? 'ranking' : ''">
            Ranking
            @if(showSorting) {
              <p-sortIcon field="ranking"></p-sortIcon>
            }
          </th>
        }
        <th style="width: 22%;" [pSortableColumn]="showSorting ? 'staffedAt' : ''">
          {{'Staff Date' | sentenceCase}}
          @if(showSorting) {
            <p-sortIcon field="staffedAt"></p-sortIcon>
          }
        </th>
        <th style="width: 12%;" [pSortableColumn]="showSorting ? 'hourlyRate' : ''">
          {{'Hourly Rate' | sentenceCase}}
          @if(showSorting) {
            <p-sortIcon field="hourlyRate"></p-sortIcon>
          }
        </th>
        @if (helperService.checkResponsive()) {
          <th alignFrozen="right" pFrozenColumn>
            <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
          </th>
          } @else {
          <th style="width: 28%" class="pr-40">
            <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
          </th>
        }
        <ng-template #frozenHeader>
        Actions
        </ng-template>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-position>
      <tr class="table-data" [class.row-selected]="selectable && isSelected(position)">
        @if(selectable) {
          <td class="pl-5 select-col">
            <input type="checkbox" class="staff-select-checkbox"
              [checked]="isSelected(position)"
              (change)="onRowSelectionToggle(position, $any($event.target).checked)"
              [attr.aria-label]="'Select ' + position.reviewer.firstName + ' ' + position.reviewer.lastName">
          </td>
        }
        <td [class.pl-5]="!selectable" class="cursor-pointer font-medium" (click)="onOpenReviewerDialog(position.reviewer._id)">
          {{ position.reviewer.firstName }} {{ position.reviewer.lastName }}
          @if(position.reviewer.favorite){
            <span class="{{helperService.getEnvironmentName()}}-icon icon-bookmark-star-outlined vibrant-pink cursor-default"
              pTooltip="Favorite" tooltipPosition="top"></span>
          }
          @if(position.reviewer.hasWorkedTogether){
            <span class="{{helperService.getEnvironmentName()}}-icon icon-group-outlined freshgreen cursor-default"
              pTooltip="Worked Together" tooltipPosition="top"></span>
          }
          @if(!isActive && position.staffedLabel !== "Accepted" && !position.isPresumptivelyPending){
            <span class="{{helperService.getEnvironmentName()}}-icon icon-check-outlined font-twnty margin-left-10"
                [ngClass]="{
                    'green-color': position.endedAcknowledgement, 
                    'gray-color': !position.endedAcknowledgement
                }"
                [pTooltip]="getEndOfRoleTooltip(position)"
                tooltipPosition="top"
                aria-hidden="true">
            </span>
          }
        </td>
        <td class="font-medium">
          <p-rating [ngModel]="getReviewerStarRating(position.reviewer)" [readonly]="true" [cancel]="false" class="cursor-default" />
        </td>
        @if(isPWCEnabled){
          <td class="font-medium">
            {{ getReviewerRanking(position.reviewer) }}
          </td>
        }
        <td>
          <p class="font-medium m-0">{{ position.staffedLabel }}&nbsp;{{ position.staffedAt | date : 'MM/dd/yyyy'}}</p>
        </td>
        <td (click)="onOpenReviewerDialog(position.reviewer._id)" class="cursor-pointer font-medium">
          Rate ${{position.hourlyRate}} /{{projectStaffList.payType === 'salary' ? 'yr' : 'hr'}}
          @if (projectStaffList.overTime > 0) {
            <span>(OT ${{projectStaffList.overTime}}/hr)</span>
          }
        </td>
        @if (helperService.checkResponsive()) {
          <td alignFrozen="right" pFrozenColumn>
            <ng-container *ngTemplateOutlet="frozenData"></ng-container>
          </td>
          } @else {
          <td class="pr-40">
            <ng-container *ngTemplateOutlet="frozenData"></ng-container>
          </td>
          } 
         <ng-template #frozenData>
           <div class="wrap-actions wrap-buttons-expandable">
             @if(position.isPresumptivelyPending){
               @if(position.status === 'PRESUMPTIVE_QUIT'){
                 <p-button [pTooltip]="'Send Offer' | sentenceCase" class="action-icon" 
                     tooltipPosition="top" (click)="onOpenImmediateSendOfferModal(position.role, position.reviewer)" 
                     [rounded]="true" [text]="true" icon="true">
                   <span class="{{helperService.getEnvironmentName()}}-icon icon-person-add-outlined"></span>
                 </p-button>
               } @else {
                 <p-button pTooltip="Presumptive" class="action-icon" 
                   tooltipPosition="top" (click)="onPresumptiveApproveDeny($event,position,projectStaffList.roleType)" 
                   [rounded]="true" [text]="true" icon="true">
                   <span class="{{helperService.getEnvironmentName()}}-icon icon-check-box-outlined"></span>
                 </p-button>
   
                 <p-button class="action-icon" pTooltip="Messaging" 
                   (click)="onOpenCreateChatReviewer(position)" 
                   tooltipPosition="top" [rounded]="true" [text]="true" icon="true">
                   <span class="{{helperService.getEnvironmentName()}}-icon icon-chat-outlined"></span>
                 </p-button>
   
                 <p-button [pTooltip]="'Send Email' | sentenceCase" class="action-icon" 
                   tooltipPosition="top" [rounded]="true" [text]="true" icon="true" 
                   (click)="onShowMailDialog(projectDetails._id, emailType.individual, projectDetails.firm, position.reviewer.firstName +' ' + position.reviewer.lastName, projectStaffList._id, position.reviewer._id)">
                   <span class="{{helperService.getEnvironmentName()}}-icon icon-mail-outlined"></span>
                 </p-button>
               }
               
             } @else {
               @if(!user.firm.isDocusignEnabled){
                 <p-button class="action-icon" 
                   [pTooltip]="getMessageNoOfDocumentUploadedByUser(position.reviewer)" 
                   tooltipPosition="top" 
                   [rounded]="true" [text]="true" icon="true"
                   (click)="onOpenReviewerDocumentDetail(position.reviewer)"
                   [disabled]="isUserCompletedOrPartiallyCompletedTheDocuments(position.reviewer) === 'NOT_UPLOADED'">
                   <span 
                     class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined"
                     [class.vibrant-pink]="isUserCompletedOrPartiallyCompletedTheDocuments(position.reviewer) === 'PARTIALLY_UPLOADED'" 
                     [class.dark-grey]="isUserCompletedOrPartiallyCompletedTheDocuments(position.reviewer) === 'NOT_UPLOADED'"
                     [class.freshgreen]="isUserCompletedOrPartiallyCompletedTheDocuments(position.reviewer) === 'UPLOADED'">
                   </span>
                 </p-button>
               }
   
               @if (projectStaffList.status !== 'ARCHIVE') {
                 @if(position.status === 'FIRED' || position.status === 'QUIT'){
                   <p-button [pTooltip]="'Send Offer' | sentenceCase" class="action-icon" 
                     tooltipPosition="top" (click)="onOpenImmediateSendOfferModal(position.role, position.reviewer)" 
                     [rounded]="true" [text]="true" icon="true">
                     <span class="{{helperService.getEnvironmentName()}}-icon icon-send-outlined"></span>
                   </p-button>
                 }
   
                 @if(position.status !== 'FIRED' && position.status !== 'QUIT' && position.status !== 'COMPLETED'){
                   @if(position.presumptive && position.presumptive.status === 'ASSIGNED'){
                     <p-button pTooltip="Approve/Deny" class="action-icon" 
                       tooltipPosition="top" (click)="onPresumptiveApproveDeny($event,position,projectStaffList.roleType)" 
                       [rounded]="true" [text]="true" icon="true">
                       <span class="{{helperService.getEnvironmentName()}}-icon icon-check-box-outlined"></span>
                     </p-button>
                   }
   
                   @if(!(position.presumptive && position.presumptive.status === 'ASSIGNED')){
                     <p-button pTooltip="Fire" class="action-icon" 
                       tooltipPosition="top" 
                       (click)="onShowFireReviewerDialog($event, position.reviewer._id, position._id, position.role, position.reviewer.firstName, position.reviewer.lastName)" 
                       [rounded]="true" [text]="true" icon="true">
                       <span class="{{helperService.getEnvironmentName()}}-icon icon-person-off-outlined red"></span>
                     </p-button>
                   }   
   
                   <p-button class="action-icon" pTooltip="Messaging" 
                     (click)="onOpenCreateChatReviewer(position)" 
                     tooltipPosition="top" [rounded]="true" [text]="true" icon="true">
                     <span class="{{helperService.getEnvironmentName()}}-icon icon-chat-outlined"></span>
                   </p-button>
   
                   <p-button [pTooltip]="'Send Email' | sentenceCase" class="action-icon" 
                     tooltipPosition="top" [rounded]="true" [text]="true" icon="true" 
                     (click)="onShowMailDialog(projectDetails._id, emailType.individual, projectDetails.firm, position.reviewer.firstName +' ' + position.reviewer.lastName, projectStaffList._id, position.reviewer._id)">
                     <span class="{{helperService.getEnvironmentName()}}-icon icon-mail-outlined"></span>
                   </p-button>
   
                   @if(isBackgroundCheckRequired){
                     <p-button class="action-icon" tooltipPosition="top" [rounded]="true" [text]="true" icon="true" 
                       [pTooltip]="position.reviewer.profile.criminalCheck.secureBackgroundResult === 'N/A' ? 
                       'No results' : (position.reviewer.profile.criminalCheck.secureBackgroundResult | sentenceCase)">
                       <span  [ngClass]="{
                           'freshgreen' : position.reviewer.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.meetsRequirement,
                           'light-grey' : position.reviewer.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.na || position.reviewer.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.needsFurtherReview,
                           'red': position.reviewer.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.doesntMeetsRequirement
                         }" class="{{helperService.getEnvironmentName()}}-icon icon-person-search"></span>
                     </p-button>
                   }
                 }  
               }
             }
           </div> 
         </ng-template>
      </tr>
    </ng-template>
  </p-table>
  }
</div>